import React from 'react';
import { Button, Modal, Table } from 'react-bootstrap';
import moment from 'moment';

const formatarData = data => (data ? moment(data).format('DD/MM/YYYY') : '-');

const formatarMoeda = valor =>
  Number(valor || 0).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });

const ModalSelecionarCheque = ({ show, cheques, onSelect, onHide }) => {
  const handleSelect = cheque => {
    onSelect(cheque);
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Selecionar Cheque</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table striped bordered hover responsive size="sm" className="mb-0">
          <thead>
            <tr>
              <th>Número</th>
              <th>Vencimento</th>
              <th className="text-right">Valor</th>
              <th>Portador</th>
              <th className="text-center">Ação</th>
            </tr>
          </thead>
          <tbody>
            {(cheques || []).map(item => (
              <tr
                key={item.codigo_titulo}
                onClick={() => handleSelect(item)}
                style={{ cursor: 'pointer' }}
              >
                <td>{item.numero}</td>
                <td>{formatarData(item.data_vencimento)}</td>
                <td className="text-right">{formatarMoeda(item.valor)}</td>
                <td>{item.apelido_conta || '-'}</td>
                <td className="text-center">
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={event => {
                      event.stopPropagation();
                      handleSelect(item);
                    }}
                  >
                    Selecionar
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalSelecionarCheque;
